// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Textarea-Wrap.module.scss  */
.Textarea-Wrap-module-Root_3wQ {
  position: relative;
  display: block;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-height: inherit; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Textarea/Wrap/Textarea-Wrap.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAE","sourcesContent":["/*  imported from Textarea-Wrap.module.scss  */\n.Textarea-Wrap-module-Root_3wQ {\n  position: relative;\n  display: block;\n  overflow: hidden;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  min-height: inherit; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
